
export function subscribeTo(subsArray, callback) {
    subsArray.forEach(s => {
        s.subscribe(() => {
            callback();
        });
    })
}